'use client'

import type { ReactNode } from 'react'

import './InfoCard.css'

interface InfoCardProps {
  title?: ReactNode
  /** Rendered via dangerouslySetInnerHTML — must be an HTML string. */
  explanation?: string
  bodyBg?: string
  bodyColor?: string
}

function InfoCard({ title, explanation, bodyBg, bodyColor }: InfoCardProps) {
  return (
    <section id="prop-eligibility" className="values section h-100">
      <div className="info-card" style={{ border: 'none' }}>
        {/* Title Section */}
        <div className="docs-required-header">{title}</div>

        {/* Explanation Section */}
        <div
          className="info-card-body"
          style={{ backgroundColor: bodyBg, color: bodyColor }}
          dangerouslySetInnerHTML={{ __html: explanation ?? '' }}
        />
      </div>
    </section>
  )
}

export default InfoCard
